export default __webpack_public_path__ + "static/media/Hamb.15d25e0e.webp";